import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import './style.scss';
import { routesUrls } from '../../settings/routes';
import { connect } from 'react-redux'
import { isTeacherOrganisationSelector } from '../../modules/profile';

class DashboardPage extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    const {isTeacherOrganisation, permission} = this.props;

    let rooms = true;
    let quizs = true;
    let statistics = true;
    let lecture_hall = true;
    let flash_card = true;

    if(isTeacherOrganisation){
      rooms = Boolean(permission.classrooms);
      quizs = Boolean(permission.quizzes);
      statistics = Boolean(permission.statistics);
      lecture_hall = Boolean(permission.lecture_hall);
      flash_card = Boolean(permission.flash_card);
    }

    return (
        <div className="dashboard">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-4 hvr-float-shadow">
              <div className="item-container">
                <Link to={routesUrls.questions} className="item-content">
                  <div className="icon">
                    <img src="/images/icon1.png"/>
                  </div>
                  <h3>{formatMessage("dashQuestionsTitle")}</h3>
                </Link>
              </div>
            </div>
            {rooms && <div className="col-xs-12 col-sm-6 col-md-4 hvr-float-shadow">
              <div className="item-container">
                <div className="item-content">
                  <Link to={routesUrls.rooms_students} className="item-content">
                    <div className="icon">
                      <img src="/images/icon5.png"/>
                    </div>
                    <h3>{formatMessage("dashRoomsAndStudentTitle")}</h3>
                  </Link>
                </div>
              </div>
            </div>}
            {quizs && <div className="col-xs-12 col-sm-6 col-md-4 hvr-float-shadow">
              <div className="item-container">
                <div className="item-content">
                  <Link to={routesUrls.quizs} className="item-content">
                    <div className="icon">
                      <img src="/images/icon3.png"/>
                    </div>
                    <h3>{formatMessage("dashStudentsTitle")}</h3>
                  </Link>              
                </div>
              </div>
            </div>}
            {statistics && <div className="col-xs-12 col-sm-6 col-md-4 hvr-float-shadow">
              <div className="item-container">
                <div className="item-content">
                  <Link to={routesUrls.statistic_reports} className="item-content">
                    <div className="icon">
                      <img src="/images/icon4.png"/>
                    </div>
                    <h3>{formatMessage("dashStatisticReports")}</h3>
                  </Link>       
                </div>
              </div>  
            </div>}
            {lecture_hall && <div className="col-xs-12 col-sm-6 col-md-4 hvr-float-shadow">
              <div className="item-container">
                <div className="item-content">
                <Link to={routesUrls.presentations} className="item-content">
                  <div className="icon">
                    <img src="/images/icon2.png"/>
                  </div>
                  <h3>{formatMessage("dashLectureHoll")}</h3>
                 </Link>
                </div>
              </div>  
            </div>}
            {flash_card && <div className="col-xs-12 col-sm-6 col-md-4 hvr-float-shadow">
              <div className="item-container">
                <div className="item-content">
                <Link to={routesUrls.card} className="item-content">
                  <div className="icon">
                    <img src="/images/flash_card.png"/>
                  </div>
                  <h3>{formatMessage("dashFlashCard")}</h3>
                 </Link>
                </div>
              </div>  
            </div>}
            {flash_card && <div className="col-xs-12 col-sm-6 col-md-4 hvr-float-shadow">
              <div className="item-container">
                <div className="item-content">
                <Link to={routesUrls.questions_multy} className="item-content">
                  <div className="icon">
                    <img src="/images/active_learning.png"/>
                  </div>
                  <h3>{formatMessage("dashDemoQuestions")}</h3>
                 </Link>
                </div>
              </div>  
            </div>}
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  permission: state.profile.permission || {},
  isTeacherOrganisation: isTeacherOrganisationSelector(state),
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/DashboardPage/index.js